export default {
      id: "icon--close-delete-x-old-usage",
      viewBox: "0 0 10.38 10.07",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--close-delete-x-old-usage",
      toString: function () {
        return this.url;
      }
    }